import axios from 'axios'
import {RemovedProduct, CheckRemovedProductsResponse} from './_models'
import {API_URL} from '../../../tenant/apiBase'

export const REMOVED_PRODUCTS_URL = `${API_URL}/api/partner-portal/ordered-products/removed-needing-confirmation`
export const CHECK_REMOVED_PRODUCTS_URL = `${API_URL}/api/partner-portal/ordered-products/check-removed-products`
export const CONFIRM_REMOVED_PRODUCT_URL = `${API_URL}/api/partner-portal/ordered-products/confirm-removed-product`

export function getRemovedProductsNeedingConfirmation(
  token: string | undefined,
  language: string,
  includeConfirmed: boolean = false,
  poId?: string | number | null
) {
  const params: any = {
    include_confirmed: includeConfirmed,
  }
  
  if (poId !== undefined && poId !== null && poId !== '') {
    params.po_id = poId
  }

  return axios.get<{data: RemovedProduct[]}>(REMOVED_PRODUCTS_URL, {
    headers: {
      token: token || '',
      language: language,
    },
    params,
  })
}

export function checkRemovedProducts(token: string | undefined, language: string) {
  return axios.get<CheckRemovedProductsResponse>(CHECK_REMOVED_PRODUCTS_URL, {
    headers: {
      token: token || '',
      language: language,
    },
  })
}

export function confirmRemovedProduct(
  removedPoItemId: number,
  token: string | undefined,
  language: string
) {
  return axios.post(
    CONFIRM_REMOVED_PRODUCT_URL,
    {removed_po_item_id: removedPoItemId},
    {
      headers: {
        token: token || '',
        language: language,
      },
    }
  )
}



